import QS from 'qs';
import { fetch } from '../utils/fetch';


export function loginUser(user) {
  return fetch({
    url: '/api/login',
    method: 'post',
    data: QS.stringify(user),
  });
}
